import { FC, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useMediaQuery } from '@mui/material';
import { ColumnFlexContainer, ContainerV2 } from '../../stories/atoms/containerV2/ContainerV2';
import { Page } from '../../stories/organisms';
import { Modal } from '../../stories/molecules';
import { muiTheme } from '../../theme';
import { usePageEventTracker } from '../../hooks/usePageEventTracker';
import { RequestNewRole } from '../requestNewRole/RequestNewRole';
import { UserInfoSection } from './UserInfoSection';
import { Preferences } from './preferences/Preferences';
import { AccessesRequested } from './accessesRequested/AccessesRequested';
import { Permissions } from './permissions/Permissions';

export const Profile: FC = observer(() => {
  usePageEventTracker('profile');

  const [showRequestNewRole, setShowRequestNewRole] = useState(false);
  const [accessesRefreshKey, setAccessesRefreshKey] = useState(0);

  const isMobile = useMediaQuery(muiTheme.breakpoints.down('tabletLandscape'));

  const renderRequestAccessModal = () => (
    <Modal isOpen={showRequestNewRole} handleClose={() => setShowRequestNewRole(false)}>
      <ContainerV2 width={isMobile ? '100%' : '600px'}>
        <RequestNewRole
          key={showRequestNewRole ? 'open' : 'closed'} // ensures re-render on reopen
          onRequestSuccess={() => {
            setShowRequestNewRole(false);
            setAccessesRefreshKey((prev) => prev + 1);
          }}
        />
      </ContainerV2>
    </Modal>
  );

  return (
    <Page
      body={
        <div data-testid="profile-page">
          {showRequestNewRole && renderRequestAccessModal()}
          <ContainerV2 display="flex" flexDirection={isMobile ? 'column' : 'row'}>
            <ColumnFlexContainer gap={[4]} padding={[4]} width={isMobile ? '100%' : '65%'}>
              <UserInfoSection onAddAccess={() => setShowRequestNewRole(true)} isMobile={isMobile} />
              <Permissions isMobile={isMobile} />
            </ColumnFlexContainer>

            <ColumnFlexContainer gap={[4]} padding={[4]} width={isMobile ? '100%' : '35%'}>
              <Preferences isMobile={isMobile} />
              <AccessesRequested isMobile={isMobile} refreshKey={accessesRefreshKey} />
            </ColumnFlexContainer>
          </ContainerV2>
        </div>
      }
    />
  );
});
